// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { usePageTypeSettingsContext } from 'contexts/page-type-settings/usePageTypeSettings';
import { PageContainer } from 'data/generated/graphql';
import { getTreatmentType } from 'utils/modules';

interface UseModuleOrderOfAppearanceArgs {
  moduleIndex: number;
  treatmentType: string | null;
}
function useModuleOrderOfAppearance() {
  const { getDTO } = useDataModelContext();
  const { pageTypeSetting, structureTreatmentTypes } = usePageTypeSettingsContext();

  function getModuleOrderOfAppearance({ moduleIndex, treatmentType }: UseModuleOrderOfAppearanceArgs) {
    if (!treatmentType) {
      return 0;
    }

    // SETTINGS_ONLY(structure-migration): treatmentTypeSettings comes from hardcoded SETTINGS; not populated for
    // structure pubs. Fall back to structureTreatmentTypes (the DynamoDB TT catalog) for those pages.
    // pageTypeSetting may be undefined for structure pubs that have no page type settings at all.
    const settingsList =
      pageTypeSetting && pageTypeSetting.treatmentTypeSettings.length > 0
        ? pageTypeSetting.treatmentTypeSettings
        : structureTreatmentTypes;
    // END SETTINGS_ONLY(structure-migration)

    if (!settingsList.length) {
      return 0;
    }

    const allTreatmentTypes = settingsList.map((type) => type.treatmentType);

    // Get the current DTO to access the module collection
    const dto = getDTO();

    const { collection } = dto.root.collection[0] as PageContainer;

    const indexesPerTreatment: Partial<Record<string, number[]>> = allTreatmentTypes.reduce<
      Partial<Record<string, number[]>>
    >((acc, type) => {
      acc[type] = [];
      return acc;
    }, {});

    collection.forEach((module, idx) => {
      const treatmentType = getTreatmentType(module.attributes.pageModule!);
      if (!treatmentType) {
        // Flat modules on structure pages have no uiModuleFields and therefore no treatment type;
        // skip them rather than throwing since they don't participate in zone ordering.
        return;
      }

      indexesPerTreatment[treatmentType]?.push(idx);
    });

    const result = (indexesPerTreatment[treatmentType] ?? []).findIndex((index) => index === moduleIndex);

    return result + 1;
  }

  return getModuleOrderOfAppearance;
}

export default useModuleOrderOfAppearance;
